export default __webpack_public_path__ + "static/media/ER3.c2c8a4ff.png";